import { Map, Record } from "immutable";

import TeacherAssignment from "./TeacherAssignment";
import TeacherAssignmentsMetaState from "./TeacherAssignmentsMetaState";

export type TeacherAssignmentsStateType = {
  assignments: Map<string, TeacherAssignment>;
  meta: TeacherAssignmentsMetaState;
};

const defaultTeacherAssignmentsState: TeacherAssignmentsStateType = {
  assignments: Map<string, TeacherAssignment>(),
  meta: new TeacherAssignmentsMetaState()
};

export default class TeacherAssignmentsState extends Record(
  defaultTeacherAssignmentsState
) {}
